import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { toElement } from '@ng-doc/ui-kit/helpers';
import { ngDocZoneDetach } from '@ng-doc/ui-kit/observables';
import { Subject, fromEvent } from 'rxjs';
import { throttleTime, map, filter, takeUntil } from 'rxjs/operators';
let NgDocOverlayStrategy = /*#__PURE__*/(() => {
  class NgDocOverlayStrategy {
    constructor(documentRef, ngZone) {
      this.documentRef = documentRef;
      this.ngZone = ngZone;
      this.overlayRef = null;
      this.destroy$ = new Subject();
    }
    attach(overlayRef) {
      this.overlayRef = overlayRef;
    }
    enable() {
      fromEvent(this.documentRef, 'scroll', {
        capture: true
      }).pipe(ngDocZoneDetach(this.ngZone), throttleTime(10), map(scrollEvent => scrollEvent.target instanceof Document ? scrollEvent.target.scrollingElement : scrollEvent.target), filter(target => target instanceof Node ? target.contains(this.origin) || !this.origin : false), takeUntil(this.destroy$)).subscribe(() => this.detach());
    }
    get origin() {
      const config = this.overlayRef?.getConfig();
      return config?.viewContainerRef ? toElement(config.viewContainerRef.element) : null;
    }
    disable() {
      this.destroy$.next();
    }
    detach() {
      this.disable();
      if (this.overlayRef?.hasAttached()) {
        this.ngZone.run(() => {
          this.overlayRef?.detach();
        });
      }
    }
    static {
      this.ɵfac = function NgDocOverlayStrategy_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocOverlayStrategy)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgDocOverlayStrategy,
        factory: NgDocOverlayStrategy.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgDocOverlayStrategy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocOverlayStrategy };
